import { ProductPurchasedNotificationProps, ProductPurchasedNotificationStateProps } from '../../types/components/products/ProductPurchasedNotification';
import { SubscriptionDetail } from '../../types/api/SubscriptionTypes';
import { ApplicationState } from '../../types/state/storeTypes';

import { NOTIFICATION_STYLE, NOTIFICATION_MOBILE_STYLE } from '../../constants/ui';

import isMobile from '../../hooks/isMobile';
import { connect, useDispatch } from 'react-redux';

import { showModal } from '../../state/actions/buyMoreCreditsActions';

const ProductPurchasedNotification: React.FC<ProductPurchasedNotificationProps> = (props) => {
  const { purchasedItem, subscription } = props;
  const mobile = isMobile();
  const dispatch = useDispatch();

  const text = purchasedItem.name ? `"${purchasedItem.name}" added to your library.` : 'Items purchased successfully.';

  const handleGetMoreCredits = () => dispatch(showModal('buy-more-credits'));;

  return (
    <div
      cy-test-id="product-purchased-notification"
      style={mobile ? NOTIFICATION_MOBILE_STYLE : NOTIFICATION_STYLE}
      className="py-6 lg:py-4 px-4 lg:px-6 rounded-[5px] align-start md:flex gap-2 lg:gap-3 md:flex-[1_0_0%] bg-gray-1000 relative"
    >
      <span className="absolute top-0 left-0 w-2 h-full bg-a-blue"/>
      <span className="block inter text-white text-[12px] lg:text-16 font-normal lg:leading-24" cy-test-id="product-name-text">
        {text}
      </span>
      <span className="lg:mt-1 inter text-a-light-gray mr-2 lg:mr-0 text-[12px] lg:text-14 font-normal lg:leading-22" cy-test-id="spent-credits-text">
        {purchasedItem.credit_price && `You spent ${purchasedItem.credit_price} of ${subscription.current_credit_balance + purchasedItem.credit_price} credits.`}
      </span>
      <span className="lg:mt-2 lg:ml-1 cursor-pointer whitespace-pre-line inter text-a-light-blue text-[12px] lg:text-14 font-normal lg:leading-22" cy-test-id="get-more-credits-link" onClick={handleGetMoreCredits}>
        Get more credits
      </span>
    </div>
  );
};

const mapStateToProps = (state: ApplicationState): ProductPurchasedNotificationStateProps => ({
  subscription: state.auth.subscription as SubscriptionDetail,
})

export default connect(mapStateToProps)(ProductPurchasedNotification);
